const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 4.25a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-1.5 0V5a.75.75 0 0 1 .75-.75m-2.03 0a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-1.5 0V5a.75.75 0 0 1 .75-.75M15.16 5a.75.75 0 0 0-1.5 0v14a.75.75 0 0 0 1.5 0zm-4.37-.75a.75.75 0 0 1 .75.75v14a.75.75 0 1 1-1.5 0V5a.75.75 0 0 1 .75-.75M5.75 5a.75.75 0 0 0-1.5 0v14a.75.75 0 0 0 1.5 0z"/></svg>';
export {
  a as w
};
